exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-configuration-general-tab .editor {\n  height: 20rem;\n  overflow: hidden;\n}\n.example-configuration-general-tab .ql-container.ql-snow {\n  height: 75% !important;\n  height: 24rem;\n}\n[dir] .example-configuration-general-tab .ql-container.ql-snow {\n  border-top: none;\n}\n.vs-tooltip {\n  z-index: 99999;\n}", ""]);

// exports
